import { Card } from "../../models/card";
export class Torch extends Card {
}
Torch.displayName = "Torch";
Torch.artUrl = "./assets/cards/torch.jpg";
